import { render, staticRenderFns } from "./Recibos.vue?vue&type=template&id=9034edb4&"
import script from "./Recibos.vue?vue&type=script&lang=js&"
export * from "./Recibos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports